import React, { Component, FunctionComponent, useState } from 'react'
import { Field, reduxForm, FormErrors } from 'redux-form'
import classnames from 'classnames'
import isEmail from 'sane-email-validation'
import { ReduxFormProps } from '../forms'
import { EyeIcon } from './eyeIcon'

export interface FormProps {
  email: string
  password: string
}

export const validateFields = (
  values: FormProps
): FormErrors<FormProps, string> => {
  const errors: Partial<FormProps> = {}
  if (!values.email) {
    errors.email = 'Email is required!'
  } else if (!isEmail(values.email)) {
    errors.email = 'Please enter a valid email!'
  }

  if (!values.password) {
    errors.password = 'Password is required!'
  }

  return errors
}

export interface Meta {
  touched: boolean
  error: string
}

export interface LoginFieldProps {
  input: any // TODO-TS
  label: string
  type: string
  placeholder: string
  meta: Meta
}

// A password input with a button that shows or hides what was typed. The input keeps
// its place in the tree whichever way it is toggled, so focus and the caret stay put.
const PasswordInput: FunctionComponent<
  React.InputHTMLAttributes<HTMLInputElement>
> = (props) => {
  const [visible, setVisible] = useState(false)

  return (
    <div className="login__password">
      <input {...props} type={visible ? 'text' : 'password'} />
      <button
        type="button"
        className="login__password-toggle"
        aria-label={visible ? 'Hide password' : 'Show password'}
        onClick={() => setVisible(!visible)}
      >
        <EyeIcon crossed={visible} />
      </button>
    </div>
  )
}

export const loginField: FunctionComponent<LoginFieldProps> = ({
  input,
  label,
  type,
  placeholder,
  meta: { touched, error },
}) => {
  const InputComponent = type === 'password' ? PasswordInput : 'input'

  return (
    <div className="form__section">
      <label htmlFor={input.name} className="form__label">
        {label}
      </label>
      {touched && error && (
        <label htmlFor={input.name} className="form__label form__label--error">
          {error}
        </label>
      )}
      <InputComponent
        {...input}
        type={type}
        id={input.name}
        placeholder={placeholder}
        className={classnames('form__input', 'form__input--full-width', {
          'form__input--error': touched && error,
        })}
      />
    </div>
  )
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Props {}

class LoginForm extends Component<ReduxFormProps<Props, FormProps>> {
  static displayName = 'LoginForm'

  render() {
    const { handleSubmit, pristine, submitting } = this.props

    return (
      <form onSubmit={handleSubmit} className="form form--align-center">
        <Field type="email" label="Email" name="email" component={loginField} />
        <Field
          type="password"
          label="Password"
          name="password"
          id="password"
          component={loginField}
        />
        <button
          className="button button--primary button--full-width"
          type="submit"
          disabled={pristine || submitting}
        >
          Login
        </button>
      </form>
    )
  }
}

export default reduxForm<FormProps, Props, string>({
  form: 'loginForm',
  validate: validateFields,
})(LoginForm)
